import React from "react";
import useAlphabetsInput from "../../hooks/useAlphabeticInput";
import useNumericInput from "../../hooks/useNumericInput";

const DynamicField = ({ field, value, onChange }) => {
   useAlphabetsInput();
  useNumericInput();
  switch (field.type) {
    case "text":
      return (
        <div className="enquiry-form-input-wrap">
          <input
            type="text"
            className="enquiry-form-input only-alphabets"
            placeholder={field.label}
            value={value || ""}
            required={field.required}
            minLength={field.min}
            maxLength={field.max}
            onChange={(e) => onChange(field.key, e.target.value)}
          />
        </div>
      );

    case "email":
      return (
        <div className="enquiry-form-input-wrap">
          <input
            type="email"
            className="enquiry-form-input"
            placeholder={field.label}
            value={value || ""}
            required={field.required}
            onChange={(e) => onChange(field.key, e.target.value)}
          />
        </div>
      );

    case "phone":
      return (
        <div className="enquiry-form-input-wrap only-numeric">
          <input
            type="tel"
            maxLength={10}
            minLength={10}
            className="enquiry-form-input"
            placeholder={field.label}
            value={value || ""}
            onChange={(e) => onChange(field.key, e.target.value)}
          />
        </div>
      );

    case "number":
      return (
        <div className="enquiry-form-input-wrap only-numeric">
          <input
            type="number"
            className="enquiry-form-input"
            placeholder={field.label}
            value={value || ""}
            onChange={(e) => onChange(field.key, e.target.value)}
          />
        </div>
      );

    case "textarea":
      return (
        <div className="enquiry-form-textarea-wrap">
          <textarea
            rows="4"
            className="enquiry-form-textarea"
            placeholder={field.label}
            value={value || ""}
            onChange={(e) => onChange(field.key, e.target.value)}
          />
        </div>
      );

    case "date":
      return (
        <div className="enquiry-form-input-wrap">
          <input
            type="date"
            className="enquiry-form-input"
            value={value || ""}
            onChange={(e) => onChange(field.key, e.target.value)}
          />
        </div>
      );

    case "select":
      return (
        <div className="enquiry-form-input-wrap">
          <select
            className="custom-ax-customize-cake-sec-input"
            value={value || ""}
            onChange={(e) => onChange(field.key, e.target.value)}
          >
            <option value="">Select {field.label}</option>

            {field.options?.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
      );

    // case "image":
    //   return (
    //     <ImageUploader
    //       type={field.key}
    //       label={field.label}
    //       value={value}
    //       assetType="customize"
    //       onUploadSuccess={
    //         handleImageUploadSuccess
    //       }
    //       onChange={(e) =>
    //         onChange(
    //           field.key,
    //           e.target.value
    //         )
    //       }
    //     />
    //   );

    default:
      return null;
  }
};

export default DynamicField;